'use strict';
import angular from 'angular';
import tiktokAudienceHtmlUrl from './views/tiktokAudienceList.html';
import tiktokChildDataHtmlUrl from './views/tiktokRecursiveTemplate.html';
let app = angular.module('app.tiktokAudience.component', []);

app.component('tiktokAudienceTargeting', {
    bindings: {
        showActions: '=',
        selectedTiktokAudience: '=',
        clusterId: '=',
        isFormEdit: '=',
        clientId: '='
    },
    templateUrl: tiktokAudienceHtmlUrl,

    // The controller that handles our component logic
    controller: function(ProductService) {
        let self = this;
        self.intrestsList = [];
        self.videoInteractionsList = [];
        self.creatorInteractionsList = [];
        self.hashtagInteractionsList = [];
        self.hashtagInteractionsSearch = '';
        self.tiktokChildDataHtmlUrl = tiktokChildDataHtmlUrl;
        self.errorFetchingIntrests = false;
        self.errorFetchingVideoInteractions = false;
        self.errorFetchingCreatorInteractions = false;

        self.IsChildObjectVisible = function(parent, child){
            let searchKey = $scope.search;
            let returnVal = true;
            if (undefined != searchKey && null != searchKey && searchKey.length > 0) {
                returnVal = ((child.name.toLowerCase().indexOf(searchKey.toLowerCase()) > -1) ||
                    (parent.name.toLowerCase().indexOf(searchKey.toLowerCase()) > -1));
            }
            return returnVal;
        }

        self.searchHashtagInteractions = function(event) {
            if (event.keyCode == 13) {
                ProductService.getHashtagInteractionsContentForTiktok({ clientId:self.clientId,clusterId:self.clusterId, keyword:self.hashtagInteractionsSearch}).then(function (success) {
                    if (success && success.data && success.data.length > 0) {
                        _.each(success.data, function (content) {
                            let hashtagInteractions = {};
                            hashtagInteractions.id = content.id;
                            hashtagInteractions.name = content.name;
                            hashtagInteractions.status = "";
                            hashtagInteractions.isChecked = false;
                            hashtagInteractions.parentName = content.parentName;;
                            hashtagInteractions.childData = content.childData;
                            self.hashtagInteractionsList.push(hashtagInteractions);
                        });
                        _.each(self.selectedTiktokAudience,function(item){
                            item.hashtagInteractionsList = angular.copy(self.hashtagInteractionsList);
                        })
                        processhashtagInteractionsData();
                    }
                }, function (error) { });
            } else {
                self.hashtagInteractionsList = [];
                _.each(self.selectedTiktokAudience,function(item){
                    item.hashtagInteractionsList = angular.copy(self.hashtagInteractionsList);
                })
            }
        }

        self.getIntrests = function() {
            ProductService.getInterestsContentForTiktok({ clientId:self.clientId,clusterId:self.clusterId}).then(function (success) {
                if (success && success.data && success.data.length > 0) {
                    self.errorFetchingIntrests = false;
                    _.each(success.data, function (content) {
                        let intrests = {};
                        intrests.id = content.id;
                        intrests.name = content.name;
                        intrests.status = "";
                        intrests.isChecked = false;
                        intrests.parentName = content.parentName;
                        intrests.childData = content.childData;
                        intrests.type = content.type;
                        self.intrestsList.push(intrests);
                    });
                    _.each(self.selectedTiktokAudience,function(item){
                        item.intrestsList = angular.copy(self.intrestsList);
                    })
                    processIntrestsData();
                } else {
                    self.errorFetchingIntrests = true;
                }
            }, function (error) { });
        }

        self.getVideoInteractions = function() {
            ProductService.getVideoInteractionsContentForTiktok({ clientId: self.clientId, clusterId: self.clusterId, parentName: 'VIDEO_RELATED'}).then(function (success) {
                if (success && success.data && success.data.length > 0) {
                    self.errorFetchingVideoInteractions = false;
                    _.each(success.data, function (content) {
                        let videoInteractions = {};
                        videoInteractions.id = content.id;
                        videoInteractions.name = content.name;
                        videoInteractions.status = "";
                        videoInteractions.isChecked = false;
                        videoInteractions.parentName = content.parentName;
                        videoInteractions.childData = content.childData;
                        videoInteractions.type = content.type;
                        self.videoInteractionsList.push(videoInteractions);
                    });
                    _.each(self.selectedTiktokAudience,function(item){
                        item.videoInteractionsList = angular.copy(self.videoInteractionsList);
                    })
                    processVideoInteractionsData();
                } else {
                    self.errorFetchingVideoInteractions = true;
                }
            }, function (error) { });
        }

        self.getCreatorInteractions = function() {
            ProductService.getCreatorInteractionsContentForTiktok({ clientId:self.clientId,clusterId:self.clusterId, parentName: 'CREATOR_RELATED'}).then(function (success) {
                if (success && success.data && success.data.length > 0) {
                    self.errorFetchingCreatorInteractions = false;
                    _.each(success.data, function (content) {
                        let creatorInteractions = {};
                        creatorInteractions.id = content.id;
                        creatorInteractions.name = content.name;
                        creatorInteractions.status = "";
                        creatorInteractions.isChecked = false;
                        creatorInteractions.parentName = content.parentName;
                        creatorInteractions.childData = content.childData;
                        creatorInteractions.type = content.type;
                        self.creatorInteractionsList.push(creatorInteractions);
                    });
                    _.each(self.selectedTiktokAudience,function(item){
                        item.creatorInteractionsList = angular.copy(self.creatorInteractionsList);
                    })
                    processCreatorInteractionsData();
                } else {
                    self.errorFetchingCreatorInteractions = true;
                }
            }, function (error) { });
        }

        self.handleSelectSubChild = function (item, child, selectedTiktokAudience, indx, type) {
            if (type == "Interests") {
                if (child.isChecked) {
                    child.status = '';
                    child.isChecked = false;
                    let selIndex = selectedTiktokAudience.intrests.indexOf(child);
                    selIndex = _.findIndex(selectedTiktokAudience.intrests, {id: child.id});
                    if (selIndex >= 0) {
                        selectedTiktokAudience.intrests.splice(selIndex, 1);
                    }
                } else {
                    child.status = 'selected';
                    child.isChecked = true;
                    selectedTiktokAudience.intrests.push(child);
                }
            } else if (type == "Video Interactions") {
                if (child.isChecked) {
                    child.status = '';
                    child.isChecked = false;
                    let selIndex = selectedTiktokAudience.videoInteractions.indexOf(child);
                    selIndex = _.findIndex(selectedTiktokAudience.videoInteractions, {id: child.id});
                    if (selIndex >= 0) {
                        selectedTiktokAudience.videoInteractions.splice(selIndex, 1);
                    }
                } else {
                    child.status = 'selected';
                    child.isChecked = true;
                    selectedTiktokAudience.videoInteractions.push(child);
                }
            } else if (type == "Creator Interactions") {
                if (child.isChecked) {
                    child.status = '';
                    child.isChecked = false;
                    let selIndex = selectedTiktokAudience.creatorInteractions.indexOf(child);
                    selIndex = _.findIndex(selectedTiktokAudience.creatorInteractions, {id: child.id});
                    if (selIndex >= 0) {
                        selectedTiktokAudience.creatorInteractions.splice(selIndex, 1);
                    }
                } else {
                    child.status = 'selected';
                    child.isChecked = true;
                    selectedTiktokAudience.creatorInteractions.push(child);
                }
            }
        }

        self.excludeAudience = function(data){
            data.overLapEnabled = false;
            data.excludeEnabled = false;
            self.selectedTiktokAudience.push({intrests: [],
                overLapEnabled:true,
                overLapAdded:false,
                excludeAdded:true,
                excludeEnabled:false,
                intrestsList:angular.copy(self.intrestsList)
            });
        }

        self.removeAudienceSet = function(data,index){
            if (self.selectedTiktokAudience.length == index + 1) {
                self.selectedTiktokAudience.splice(index, 1);
                let selIndex = index - 1;
                if (selIndex >= 0) {
                    self.selectedTiktokAudience[selIndex].excludeEnabled = true;
                    self.selectedTiktokAudience[selIndex].overLapEnabled = true;
                    if (data.excludeAdded) {
                        self.hideExclude = false;
                    }
                }
            } else {
                self.selectedTiktokAudience.splice(index, 1);
                if (data.excludeAdded) {
                    self.hideExclude = false;
                    let indexVal = self.selectedTiktokAudience.length-1;
                    self.selectedTiktokAudience[indexVal].excludeEnabled = true;
                }
            }
        }
        let processhashtagInteractionsData = function () {
            _.each(self.selectedTiktokAudience, function (data) {
                _.each(data.hashtagInteractions, function (item) {
                    _.each(data.hashtagInteractionsList, function (e) {
                        if (e.id == item.id) {
                            e.status = 'selected';
                            e.isChecked = true;
                        }
                    })
                })
            })
        }

        self.handleSelectHashtagInteractions = function (hashtagInteractions, selectedTiktokAudience) {
            if (!hashtagInteractions.isChecked) {
                hashtagInteractions.status = '';
                hashtagInteractions.isChecked = false;
                let selIndex = selectedTiktokAudience.hashtagInteractions.indexOf(hashtagInteractions);
                if (selIndex >= 0) {
                    selectedTiktokAudience.hashtagInteractions.splice(selIndex, 1);
                } else {
                    if (selectedTiktokAudience.hashtagInteractions && selectedTiktokAudience.hashtagInteractions.length > 0) {
                        if (_.find(selectedTiktokAudience.hashtagInteractionsList, { id: hashtagInteractions.id })) {
                            let index = _.findIndex(selectedTiktokAudience.hashtagInteractionsList, { id: hashtagInteractions.id });
                            selectedTiktokAudience.hashtagInteractions.splice(index, 1);
                        }
                    }
                }
            } else {
                hashtagInteractions.status = 'selected';
                hashtagInteractions.isChecked = true;
                selectedTiktokAudience.hashtagInteractions.push(hashtagInteractions);
            }
        }

        let processIntrestsData = function () {
            _.each(self.selectedTiktokAudience, function (data) {
                _.each(data.intrests, function (item) {
                    _.each(data.intrestsList, function (e) {
                        if (e.id == item.id) {
                            e.status = 'selected';
                            e.isChecked = true;
                        }
                        if (e.childData && e.childData.length > 0) {
                            processSubIntrests(e.childData,data.intrests);
                        }
                    })
                })
            })
        }

        let processSubIntrests = function(childData,selectedIntrests){
            _.each(selectedIntrests,function(item){
                _.each(childData,function(e){
                    if (e.id == item.id) {
                        e.status = 'selected';
                        e.isChecked = true;
                    }
                    if (e.childData && e.childData.length > 0) {
                        processSubIntrests(e.childData,selectedIntrests);
                    }
                })
            })
        }

        self.handleSelectIntrests = function (intrests, selectedTiktokAudience) {
            if (!intrests.isChecked) {
                intrests.status = '';
                intrests.isChecked = false;
                let selIndex = selectedTiktokAudience.intrests.indexOf(intrests);
                if (selIndex >= 0) {
                    selectedTiktokAudience.intrests.splice(selIndex, 1);
                } else {
                    if (selectedTiktokAudience.intrests && selectedTiktokAudience.intrests.length > 0) {
                        if (_.find(selectedTiktokAudience.intrestsList, { id: intrests.id })) {
                            let index = _.findIndex(selectedTiktokAudience.intrestsList, { id: intrests.id });
                            selectedTiktokAudience.intrests.splice(index, 1);
                        }
                    }
                }
            } else {
                intrests.status = 'selected';
                intrests.isChecked = true;
                selectedTiktokAudience.intrests.push(intrests);
            }
        }

        let processVideoInteractionsData = function () {
            _.each(self.selectedTiktokAudience, function (data) {
                _.each(data.videoInteractions, function (item) {
                    _.each(data.videoInteractionsList, function (e) {
                        if (e.id == item.id) {
                            e.status = 'selected';
                            e.isChecked = true;
                        }
                        if (e.childData && e.childData.length > 0) {
                            processSubVideoInteractions(e.childData,data.videoInteractions);
                        }
                    })
                })
            })
        }

        let processSubVideoInteractions = function(childData,selectedVideoInteractions){
            _.each(selectedVideoInteractions,function(item){
                _.each(childData,function(e){
                    if (e.id == item.id) {
                        e.status = 'selected';
                        e.isChecked = true;
                    }
                    if (e.childData && e.childData.length > 0) {
                        processSubVideoInteractions(e.childData,selectedVideoInteractions);
                    }
                })
            })
        }

        self.handleSelectVideoInteractions = function (videoInteractions, selectedTiktokAudience) {
            if (!videoInteractions.isChecked) {
                videoInteractions.status = '';
                videoInteractions.isChecked = false;
                let selIndex = selectedTiktokAudience.videoInteractions.indexOf(videoInteractions);
                if (selIndex >= 0) {
                    selectedTiktokAudience.videoInteractions.splice(selIndex, 1);
                } else {
                    if (selectedTiktokAudience.videoInteractions && selectedTiktokAudience.videoInteractions.length > 0) {
                        if (_.find(selectedTiktokAudience.videoInteractionsList, { id: videoInteractions.id })) {
                            let index = _.findIndex(selectedTiktokAudience.videoInteractionsList, { id: videoInteractions.id });
                            selectedTiktokAudience.videoInteractions.splice(index, 1);
                        }
                    }
                }
            } else {
                videoInteractions.status = 'selected';
                videoInteractions.isChecked = true;
                selectedTiktokAudience.videoInteractions.push(videoInteractions);
            }
        }

        let processCreatorInteractionsData = function () {
            _.each(self.selectedTiktokAudience, function (data) {
                _.each(data.creatorInteractions, function (item) {
                    _.each(data.creatorInteractionsList, function (e) {
                        if (e.id == item.id) {
                            e.status = 'selected';
                            e.isChecked = true;
                        }
                        if (e.childData && e.childData.length > 0) {
                            processSubCreatorInteractions(e.childData,data.creatorInteractions);
                        }
                    })
                })
            })
        }

        let processSubCreatorInteractions = function(childData,selectedCreatorInteractions){
            _.each(selectedCreatorInteractions,function(item){
                _.each(childData,function(e){
                    if (e.id == item.id) {
                        e.status = 'selected';
                        e.isChecked = true;
                    }
                    if (e.childData && e.childData.length > 0) {
                        processSubCreatorInteractions(e.childData,selectedCreatorInteractions);
                    }
                })
            })
        }

        self.handleSelectCreatorInteractions = function (creatorInteractions, selectedTiktokAudience) {
            if (!creatorInteractions.isChecked) {
                creatorInteractions.status = '';
                creatorInteractions.isChecked = false;
                let selIndex = selectedTiktokAudience.creatorInteractions.indexOf(creatorInteractions);
                if (selIndex >= 0) {
                    selectedTiktokAudience.creatorInteractions.splice(selIndex, 1);
                } else {
                    if (selectedTiktokAudience.creatorInteractions && selectedTiktokAudience.creatorInteractions.length > 0) {
                        if (_.find(selectedTiktokAudience.creatorInteractionsList, { id: creatorInteractions.id })) {
                            let index = _.findIndex(selectedTiktokAudience.creatorInteractionsList, { id: creatorInteractions.id });
                            selectedTiktokAudience.creatorInteractions.splice(index, 1);
                        }
                    }
                }
            } else {
                creatorInteractions.status = 'selected';
                creatorInteractions.isChecked = true;
                selectedTiktokAudience.creatorInteractions.push(creatorInteractions);
            }
        }

        self.clearSelectedData = function(item,totalList){
            _.each(totalList,function(e){
                if (e.id == item.id) {
                    e.status = '';
                    e.isChecked = false;
                }
                if (e.childData && e.childData.length > 0) {
                    self.clearSelectedData(item,e.childData)
                }
            })
        }

        //method to handle parent selection
        self.handleSelectParent = function (parent, data) {
            if (parent.parentChecked) {
                // Parent is selected, unselect all child items
                _.each(parent.childData, function (childItem) {
                    childItem.isChecked = false;
                });
            }
        };

        //method to handle child selection
        self.handleSelectChild = function (parent, child, data) {
            if (child.isChecked) {
                // Child is selected, unselect parent
                parent.parentChecked = false;
            } else {
                // Child is unselected, check if all children are unselected
                let allUnchecked = _.every(parent.childData, function (childItem) {
                    return !childItem.isChecked;
                });
                if (allUnchecked) {
                    parent.parentChecked = true;
                }
            }
        };

        self.removeIntrests = function (item, selectedIntrests, intrestsList) {
            let selIndex = selectedIntrests.indexOf(item);
            if (selIndex >= 0) {
                selectedIntrests.splice(selIndex, 1);
                self.clearSelectedData(item,intrestsList);
            }
        }

        self.removeVideoInteractions = function (item, selectedVideoInteractions, videoInteractionsList) {
            let selIndex = selectedVideoInteractions.indexOf(item);
            if (selIndex >= 0) {
                selectedVideoInteractions.splice(selIndex, 1);
                self.clearSelectedData(item,videoInteractionsList);
            }
        }

        self.removeCreatorInteractions = function (item, selectedCreatorInteractions, creatorInteractionsList) {
            let selIndex = selectedCreatorInteractions.indexOf(item);
            if (selIndex >= 0) {
                selectedCreatorInteractions.splice(selIndex, 1);
                self.clearSelectedData(item,creatorInteractionsList);
            }
        }

        self.removehashtagInteractions = function (item, selectedHashtagInteractions, hashtagInteractionsList) {
            let selIndex = selectedHashtagInteractions.indexOf(item);
            if (selIndex >= 0) {
                selectedHashtagInteractions.splice(selIndex, 1);
                self.clearSelectedData(item,hashtagInteractionsList);
            }
        }

        self.setExclude = function(){
            _.each(self.selectedTiktokAudience,function(item){
                if (item.excludeAdded) {
                    self.hideExclude = true;
                }
            })
        }

        self.initComponent = function () {
            if (self.selectedTiktokAudience && !_.isEmpty(self.selectedTiktokAudience)) {
                self.selectedTiktokAudience = JSON.parse(self.selectedTiktokAudience);
                if (self.showActions) {
                    self.editMode = true;
                    self.enableViewMode = false;
                    self.getIntrests();
                    self.getVideoInteractions();
                    self.getCreatorInteractions();
                } else {
                    self.editMode = false;
                    self.enableViewMode = true;
                }
            } else {
                self.selectedTiktokAudience = [{
                    intrests: [],
                    videoInteractions: [],
                    creatorInteractions: [],
                    hashtagInteractions: [],
                    overLapEnabled:true,
                    excludeEnabled:true
                }];
                self.enableViewMode = false;
                self.getIntrests();
                self.getVideoInteractions();
                self.getCreatorInteractions();
            }
        };
        self.initComponent();
    }
});